import { render, staticRenderFns } from "./PriceUpdateNoticeModal.vue?vue&type=template&id=34cdf47c&scoped=true"
import script from "./PriceUpdateNoticeModal.vue?vue&type=script&lang=ts"
export * from "./PriceUpdateNoticeModal.vue?vue&type=script&lang=ts"
import style0 from "./PriceUpdateNoticeModal.vue?vue&type=style&index=0&id=34cdf47c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cdf47c",
  null
  
)

export default component.exports